import { FC, useState } from 'react';
import CalendarIcon from 'assets/icons/calendar-icon.svg';
import clsx from 'clsx';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { setViewScheduleStage } from 'entities/viewStage';
import { useHistoryOfViewStage } from 'shared/hooks';
import { useAppDispatch, useAppSelector } from 'shared/lib';
import {
  CalendarViewIcon,
  ColumnViewIcon,
  TableViewIcon,
  TimeLineViewIcon,
} from 'shared/ui/Icons/Icons';

import { CalendarSchedule } from '../../calendarSchedule/ui';
import { formatToCalendarLabel } from '../lib';

import 'dayjs/locale/ru';

import styles from './styles.module.scss';

dayjs.extend(localizedFormat);
dayjs.locale('ru');

export const SettingsToolbar: FC = () => {
  const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false);

  const { scheduleViewStage } = useAppSelector(
    (state) => state.viewStageReducer,
  );

  const { startIntervalDate } = useAppSelector(
    (state) => state.schedulePublicReducer,
  );
  const dispatch = useAppDispatch();

  const { setViewScheduleHistory } = useHistoryOfViewStage();

  return (
    <div className={styles['settings-toolbar']}>
      <div className={styles['settings-toolbar__calendar']}>
        <div
          className={styles['settings-toolbar__calendar-button']}
          onClick={() => setIsCalendarOpen((prev) => !prev)}
        >
          <img src={CalendarIcon} alt="Календарь" />
          <div className={styles['settings-toolbar__calendar-text']}>
            {formatToCalendarLabel(startIntervalDate)}
          </div>
        </div>
        <div
          className={clsx(styles['settings-toolbar__calendar-modal'], {
            [styles['settings-toolbar__calendar-modal_acitve']]: isCalendarOpen,
          })}
        >
          <CalendarSchedule
            isCalendarOpen={isCalendarOpen}
            setIsCalendarOpen={() => {
              setIsCalendarOpen((prev) => !prev);
            }}
          />
        </div>
      </div>

      <div className={styles['settings-toolbar__view-controls']}>
        <button
          className={clsx(
            styles['settings-toolbar__view-btn'],
            styles['column'],
            {
              [styles['settings-toolbar__view-btn_active']]:
                scheduleViewStage === 'column',
            },
          )}
          onClick={() => {
            dispatch(setViewScheduleStage('column'));
            setViewScheduleHistory('column');
          }}
        >
          <TableViewIcon />
        </button>
        <button
          className={clsx(
            styles['settings-toolbar__view-btn'],
            styles['timeline'],
            {
              [styles['settings-toolbar__view-btn_active']]:
                scheduleViewStage === 'timeline',
            },
          )}
          onClick={() => {
            dispatch(setViewScheduleStage('timeline'));
            setViewScheduleHistory('timeline');
          }}
        >
          <TimeLineViewIcon />
        </button>
        <button
          className={clsx(
            styles['settings-toolbar__view-btn'],
            styles['table'],
            {
              [styles['settings-toolbar__view-btn_active']]:
                scheduleViewStage === 'table',
            },
          )}
          onClick={() => {
            dispatch(setViewScheduleStage('table'));
            setViewScheduleHistory('table');
          }}
        >
          <ColumnViewIcon />
        </button>
        <button
          className={clsx(
            styles['settings-toolbar__view-btn'],
            styles['calendar'],
            {
              [styles['settings-toolbar__view-btn_active']]:
                scheduleViewStage === 'calendar',
            },
          )}
          onClick={() => {
            dispatch(setViewScheduleStage('calendar'));
            setViewScheduleHistory('calendar');
          }}
        >
          <CalendarViewIcon />
        </button>
      </div>
    </div>
  );
};
